import React, { useState } from 'react';
import { db } from '../FirebaseComp/firebase'; // Import your Firebase configuration
import { collection, addDoc } from 'firebase/firestore';
import './joinus.css';

function JoinUs() {


    const [activeTab, setActiveTab] = useState('volunteer');
    const [formData, setFormData] = useState({
      name: '',
      email: '',
      phone: '',
      interest: activeTab,
      skills: '',
      organization: '',
      message: '',
      availability: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
  
    const handleTabChange = (tab) => {
      setActiveTab(tab);
      setFormData({...formData, interest: tab});
    };
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({...formData, [name]: value});
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsSubmitting(true);
      
      try {
        // Add a new document with a generated id to the "joinUs" collection
        const docRef = await addDoc(collection(db, "joinUs"), {
          ...formData,
          timestamp: new Date()
        });
        
        console.log("Document written with ID: ", docRef.id);
        setSubmitSuccess(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          interest: activeTab,
          skills: '',
          organization: '',
          message: '',
          availability: ''
        });
      } catch (error) {
        console.error("Error adding document: ", error);
      } finally {
        setIsSubmitting(false);
      }
    };

    


  if (submitSuccess) {
    return (
      <div className="success-container">
        <div className="success-animation">
          <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
        <h2>Thank You for Your Interest!</h2>
        <p>We've received your information and will contact you soon.</p>
        <button 
          className="back-button"
          onClick={() => setSubmitSuccess(false)}
        >
          Submit Another Response
        </button>
      </div>
    );
  }

  return (
    <div className="join-us-container">
      <div className="header-section">
        <h1>Join Our Movement</h1>
        <p>Be part of creating positive change in Sri Lanka</p>
      </div>

      <div className="tab-container">
        <button 
          className={`tab-button ${activeTab === 'volunteer' ? 'active' : ''}`}
          onClick={() => handleTabChange('volunteer')}
        >
          Volunteer
        </button>
        <button 
          className={`tab-button ${activeTab === 'involved' ? 'active' : ''}`}
          onClick={() => handleTabChange('involved')}
        >
          Get Involved
        </button>
        <button 
          className={`tab-button ${activeTab === 'partner' ? 'active' : ''}`}
          onClick={() => handleTabChange('partner')}
        >
          Partner With Us
        </button>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name*</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email*</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          {activeTab === 'volunteer' && (
            <>
              <div className="form-group">
                <label htmlFor="skills">Skills/Expertise</label>
                <input
                  type="text"
                  id="skills"
                  name="skills"
                  value={formData.skills}
                  onChange={handleChange}
                  placeholder="What skills can you contribute?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="availability">Availability</label>
                <select
                  id="availability"
                  name="availability"
                  value={formData.availability}
                  onChange={handleChange}
                >
                  <option value="">Select your availability</option>
                  <option value="weekdays">Weekdays</option>
                  <option value="weekends">Weekends</option>
                  <option value="both">Both</option>
                  <option value="flexible">Flexible</option>
                </select>
              </div>
            </>
          )}

          {activeTab === 'partner' && (
            <div className="form-group">
              <label htmlFor="organization">Organization Name</label>
              <input
                type="text"
                id="organization"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                required
              />
            </div>
          )}

          <div className="form-group">
            <label htmlFor="message">
              {activeTab === 'partner' 
                ? 'Tell us about your organization and partnership ideas*' 
                : 'Why do you want to join us?*'}
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
            />
          </div>

          <button 
            type="submit" 
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>

        <div className="info-section">
          <h3>Benefits of Joining Us?</h3>
          <ul>
            <li>Travel with a purpose</li>
            <li>Volunteering opportunities</li>
            <li>Build network - people around you will gather for purpose</li>
            <li>Connect with us and connect with world</li>
            {/* <li style="color: red;">Now it's your turn</li> */}
            <li style={{ color: 'red' }}>Now it's your turn</li>


          </ul>








          <div className="contact-info">
            <h3>Have Questions?</h3>
        <p> cecc.moratuwa@gmail.com / cecc.maradana@gmail.com</p>
            <p>Call us: 011 77 00 904 / 011 77 00 906</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JoinUs;